<template>
  <BaseDialog
    v-model="internalValue"
    @input="$emit('input', $event)"
    :title="'Edita Esdeveniment'"
    :cancelText="'Cancel·la'"
    :confirmText="'Desa'"
    :loading="loading"
    :maxWidth="'600px'"
    :backgroundColor="'#f9efd5'"
    :confirmColor="'#ffc107'"
    role="dialog"
    aria-modal="true"
    @cancel="onCancel"
    @confirm="onConfirm"
  >
    <v-form ref="form">
        <template v-if="event.type === 'ready'">
            <v-textarea
              auto-grow
              rows="1"
              :label="'Alineacions'"
              :value="localEditableEventData"
              :disabled="true"
            ></v-textarea>
        </template>
        <template v-else>
            <!-- Time -->
            <v-text-field
              v-model="localEditableEvent.data.time"
              type="number"
              min="0"
              :label="'Minut'"
              :rules="requiredRule"
            />
      
            <!-- Team -->
            <v-select
              v-model="localEditableEvent.data.team"
              :items="teamOptions"
              item-value="id"
              item-text="name"
              :label="'Equip'"
              :rules="requiredRule"
            >
              <template slot="selection" slot-scope="{ item }">
                <v-avatar size="32" class="mr-2" v-if="item && item.shield">
                  <img :src="item.shield" :alt="item.name" />
                </v-avatar>
                {{ item && item.name ? item.name : '' }}
              </template>
      
              <template slot="item" slot-scope="{ item }">
                <v-list-tile-avatar v-if="item.shield">
                  <img :src="item.shield" :alt="item.name" />
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title>{{ item.name }}</v-list-tile-title>
                </v-list-tile-content>
              </template>
            </v-select>
      
            <!-- Player selector if needed -->
            <v-select
              v-if="config.requiresPlayer"
              v-model="localEditableEvent.data.player_id"
              :items="availablePlayers"
              item-value="value"
              item-text="name"
              :label="'Jugador'"
              :rules="requiredRule"
            >
              <!-- Selected item -->
              <template slot="selection" slot-scope="{ item }">
      
                <v-avatar size="24" class="mr-2" :style="{ backgroundColor: '#003784' }">
                  <span class="subtitle-2 white--text">{{ item.number }}</span>
                </v-avatar>
                {{ item.name }}
              </template>
      
              <!-- Dropdown list item -->
              <template slot="item" slot-scope="{ item }">
                <v-list-tile-avatar>
                  <v-avatar
                    size="32"
                    :style="{ backgroundColor: '#003784' }"
                  >
                    <span class="subtitle-2 white--text">{{ item.number }}</span>
                  </v-avatar>
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title>{{ item.name }}</v-list-tile-title>
                </v-list-tile-content>
              </template>
            </v-select>
      
            <!-- Description (computed for player-events or static) -->
            <v-text-field
              :value="computedDescription"
              :label="'Descripció'"
              disabled
            ></v-text-field>
      
            <!-- Subtype for redcard or injury -->
            <v-select
              v-if="config.showSubtype"
              v-model="localEditableEvent.data.subtype"
              :items="config.subtypeOptions"
              item-text="text"
              item-value="value"
              :label="'Subtipo'"
              clearable
              @input="onSubtypeInput"
            ></v-select>
      
            <!-- Comment for redcard or injury -->
            <v-text-field
              v-if="config.showComment"
              v-model="localEditableEvent.data.comment"
              :label="'Comentari'"
            ></v-text-field>
      
            <!-- Ambulance flag for injury -->
            <v-switch
              v-if="event.type === 'injury'"
              v-model="localEditableEvent.data.ambulance"
              :label="'Ambulància'"
            ></v-switch>
        </template>
    </v-form>
  </BaseDialog>
</template>

<script>
import BaseDialog from './BaseDialog.vue'

export default {
  name: 'EditEventDialog',
  components: { BaseDialog },
  props: {
    value: { type: Boolean, required: true },
    event: Object,
    matchTeams: Object,
    loading: { type: Boolean, default: false }
  },
  data () {
    return {
      requiredRule: [v => !!v || 'Aquest camp és obligatori'],
      localEditableEvent: JSON.parse(JSON.stringify(this.event)),
      localEditableEventData: JSON.stringify(this.event.data),
      redCardSubtypes: [
        { value: '321g', text: '321g: ' + this.$t('punishment.321g') },
        { value: '336', text: '336: ' + this.$t('punishment.336') },
        { value: '337', text: '337: ' + this.$t('punishment.337') },
        { value: '338a', text: '338a: ' + this.$t('punishment.338a') },
        { value: '338c', text: '338c: ' + this.$t('punishment.338c') },
        { value: '338d', text: '338d: ' + this.$t('punishment.338d') },
        { value: '338f', text: '338f: ' + this.$t('punishment.338f') },
        { value: '338.2b', text: '338.2b: ' + this.$t('punishment.3382b') },
        { value: '339', text: '339: ' + this.$t('punishment.339') },
        { value: '355sc', text: '355sc: ' + this.$t('punishment.355sc') }
      ],
      injuryTypes: [
        { value: 'Lleu', text: 'Lleu' },
        { value: 'Mitjana', text: 'Mitjana' },
        { value: 'Greu', text: 'Greu' }
      ],
      eventConfigs: {
        goal: { showDescription: false, requiresPlayer: true },
        autogoal: { showDescription: false, requiresPlayer: true },
        changein: { showDescription: false, requiresPlayer: true },
        changeout: { showDescription: false, requiresPlayer: true },
        yellowcard: { showDescription: false, requiresPlayer: true },
        redcard: { showDescription: false, requiresPlayer: true, showSubtype: true, showComment: true, subtypeOptions: [] },
        injury: { showDescription: false, requiresPlayer: true, showSubtype: true, showComment: true, showAmbulance: true, subtypeOptions: [] },
        corner: { showDescription: false, requiresPlayer: false },
        offside: { showDescription: false, requiresPlayer: false }
      }
    }
  },
  created () {
    this.eventConfigs.redcard.subtypeOptions = this.redCardSubtypes
    this.eventConfigs.injury.subtypeOptions = this.injuryTypes
  },
  computed: {
    internalValue: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    config () {
      return this.eventConfigs[this.localEditableEvent.type] || {}
    },
    teamOptions () {
      return ['home', 'away'].map(key => {
        const team = this.matchTeams[key] || {}
        return {
          id: key, // 'home' or 'away'
          name: team.name || key,
          shield: team.shield || null
        }
      })
    },
    availablePlayers () {
      if (!this.config.requiresPlayer) return []

      let teamKey = null
      const team = this.localEditableEvent.data.team
      if (typeof team === 'string') {
        teamKey = team
      } else if (team && team.id) {
        teamKey = team.id
      }

      const players = (this.matchTeams[teamKey] || {}).players || {}
      return Object.values(players).map(p => ({
        value: p.id,
        number: p.number,
        name: p.name.split(' ')[0].toUpperCase()
      }))
    },
    computedDescription () {
      if (this.config.requiresPlayer) {
        const sel = this.availablePlayers.find(
          i => i.value === this.localEditableEvent.data.player_id
        )
        // build the string yourself:
        return sel ? `(${sel.number}) ${sel.name}` : ''
      }
      return this.localEditableEvent.data.description
    }
  },
  watch: {
    event (newVal) {
      this.localEditableEvent = JSON.parse(JSON.stringify(newVal))
    },
    'localEditableEvent.data.team': function () {
      if (!this.localEditableEvent.data.player_id) {
        return
      }
      this.localEditableEvent.data.player_id = null
    }
  },
  methods: {
    onCancel () {
      if (this.loading) return
      this.$emit('input', false) // close the dialog
    },
    onConfirm () {
      if (!this.$refs.form.validate()) return
      this.localEditableEvent.data.description = this.computedDescription
      if(this.localEditableEvent.type === 'ready') {
        this.localEditableEvent.data = JSON.parse(this.localEditableEventData)
      }
      this.$emit('confirm', JSON.stringify(this.localEditableEvent))
    },
    onSubtypeInput (value) {
      this.localEditableEvent.data.subtype = value === undefined ? '' : value
    }
  }
}
</script>
